/*
 * File: d:\projects\AutoFiFront\src\Content\Financement\Financement.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 29th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday March 29th 2023 5:25:54 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { Fragment } from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import Styles from "Content/Financement/Financement.module.css";
import CollapseBox2 from 'Content/CollapseBox/CollapseBox2';
import { NavLink } from 'react-router-dom';
import RouterPathResolver from 'Config/Router/RouterPathResolver';

function Financement (_: any) {
    const financeOption = ["loa", "lld", "cb", "newOrUsed", "solution"];

    return (
        <Fragment>
            <h1 className={`${Styles.heading}`}>{translator.decode("financementText.titlePart1")}</h1>
            <div className={`${Styles.descriptionHolder}`}>
                {
                    financeOption.map((item: string, index: number)=>{ return <CollapseBox2 context={item} key={`${item}+${index}`}/> })
                }
                <NavLink className={`${Styles.btnGoTo}`} to={RouterPathResolver.routeFinanceFaq.path}> <div> {translator.decode("financementPage.faq")} </div> </NavLink>
            </div>
        </Fragment>
    );
};

export default Financement;
